<template>
  <b-modal
    id="beacon-details-modal"
    :title="$t('BEACON.DETAILS')"
    title-class="h4 font-weight-bold"
    lazy
    size="xl"
    hide-footer
  >
    <div class="d-flex px-3 py-5 mt-5 flex-column">
      <DeviceBeaconEditForm></DeviceBeaconEditForm>
    </div>
  </b-modal>
</template>

<script>
import DeviceBeaconEditForm from "@/modules/device/components/facial/DeviceBeaconEditForm";
export default {
  name: "DeviceBeaconModal",
  components: { DeviceBeaconEditForm },
  data() {
    return {
      currentTab: 0,
      busy: false,
    };
  },
};
</script>

<style scoped></style>
